import IService from "@api/iService";
import {PatchGameAccountModel, PutGameAccountModel} from "@models/user/data";
import {UserChargeAccount} from "@models/user/payments";
import {GameAccount, GameCharacter} from "@interfaces/game";

export default class GameService extends IService {

    async putAccount(account: PutGameAccountModel) {
        return await this.putApi('/api/user/game/account/', account);
    }

    async patchAccount(account: PatchGameAccountModel) {
        return await this.patchApi('/api/user/game/account/', account);
    }

    async chargeGameAccount(charge: UserChargeAccount) {
        return await this.postApi('/api/user/game/account/', charge);
    }

    async fetchCharacters() {
        return await this.getApi<GameCharacter[]>('/api/user/game/characters/');
    }

    async fetchAccounts() {
        return await this.getApi<GameAccount[]>('/api/user/game/account/');
    }

    async fetchAccount(accountId: string): Promise<GameAccount> {
        return await this.getAndThrowApi<GameAccount>(`/api/user/game/account/${accountId}/`);
    }
}